import React from "react";
import { DateTime } from "luxon";
import { EmptyCell } from "./empty-cell.component";
import { m } from "kremling";

type DateCellProps = {
  isDisabled?: boolean;
} & (
  | {
      value: string;
      columnSchema: {
        dataType: "date_iso";
      };
    }
  | {
      value: number;
      columnSchema: {
        dataType: "date_unix_ms";
      };
    }
);

export function DateCell({ value, columnSchema, isDisabled }: DateCellProps) {
  const { dataType } = columnSchema;
  let dateTime: DateTime | null = null;

  if (dataType === "date_iso" && typeof value === "string") {
    dateTime = DateTime.fromISO(value);
  } else if (dataType === "date_unix_ms" && typeof value === "number") {
    dateTime = DateTime.fromMillis(value);
  } else {
    console.error(`Unsupported dataType '${dataType}' for DateCell`);
  }

  return dateTime ? (
    <span className={m("cp-data-table-cell-disabled", isDisabled)}>
      {dateTime.toLocaleString(DateTime.DATE_SHORT)}
    </span>
  ) : (
    <EmptyCell isDisabled={isDisabled} />
  );
}
